// extracted by mini-css-extract-plugin
module.exports = {"link":"TextItem__link--white--eEy9U","item":"TextItem__item--white--3VGd0","isSubmenuOpen":"TextItem__isSubmenuOpen--white--2cGq1","isActive":"TextItem__isActive--white--2s-9N"};
    if(module.hot) {
      // 1617221670015
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  